export default __webpack_public_path__ + "static/media/how-it-works-dots.27728774.svg";